import { gql } from '@common/hooks';
import {
  BillingStatsItemFragment,
  BillingStatsItemFragmentType,
} from '@pay-bill/graphql/fragments';

export const WorksBillingStatsQuery = gql`
  query WorksBillingStats {
    stats: worksBillingStats {
      ...BillingStatsItemFragment
    }
  }
  ${BillingStatsItemFragment}
`;

export type WorksBillingStatsQueryResponse = {
  stats: BillingStatsItemFragmentType[];
};
